module.exports = __webpack_public_path__ + "img/signup.b587b8c1.jpg";